import cx from 'classnames';
import dynamic from 'next/dynamic';
import ReactPlayer from 'react-player';
import { useState } from 'react';

import useWindowSize from '#app/hooks/useWindowSize';
import { toPX } from '#app/helpers/toPX';

import styles from './index.module.scss';

const Typography = dynamic(import('#app/UI/atoms/new-typography'));

const Preview = ({ youtubeId, className, background }) => {
  const [playState, setPlayState] = useState(false);
  const { isDesktop } = useWindowSize();

  const playVideo = () => setPlayState(true);

  return (
    <section className={styles.wrapper}>
      <div
        className={cx(
          className,
          'flex sm_flex-col gap-x-32 gap-y-24 sm_gap-y-20 sm_px-20',
          styles.container
        )}
      >
        {/* Video */}
        <div className={styles.video} onClick={() => playVideo()}>
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${youtubeId}&ab_channel=CrackTheCode`}
            playing={playState}
            volume={0.5}
            width={toPX(isDesktop, [419, '100%'])}
            height={toPX(isDesktop, [234, 188])}
            light
            playIcon={
              <div className={styles.play} style={{ background }}>
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 43 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43 27.4337L0.249997 54.6562L0.25 0.21121L43 27.4337Z"
                    fill="white"
                  />
                </svg>
              </div>
            }
          />
        </div>

        {/* Text */}
        <div className={cx('my-auto', styles.text)}>
          <Typography className="typo-32 rockone" tag="h2">
            <span style={{ color: '#B845FF' }}>
              Descubre {isDesktop && <br />} cómo lo hacemos <br />
            </span>{' '}
            en este video {isDesktop && <br />} de 1 minuto
          </Typography>
        </div>
      </div>
    </section>
  );
};

export default Preview;
